import React from "react";

const NotFound = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <h1>
        <div>404</div>
        <div>Страница не найдена</div>
      </h1>
      <p>Извините, но страница, которую вы ищете, не существует.</p>
    </div>
  );
};

export default NotFound;
